
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class TariffSettingsTooltip extends Vue {
  show = false;
}
